// Company data
export const CompanyName = 'Mistress Diva';
export const CompanyPhoneNumber = '07846286385';
export const ContactEmailAddress = 'MistressDiva@protonmail.com';
export const DirectorName = 'Mistress Diva';
export const LocationCity = 'Perth';
export const CurrentLocation = 'Perth';
export const LocationCountry = 'Australia';

export const CompanyTagLine = `Available in ${LocationCity}, ${LocationCountry}`;
export const MainTitle = 'Your Dominant...Your Mistress...Your Goddess';
export const SubtitleMain = 'Bringing pleasure to submissives!';
export const SubtitleSecondary = `How can ${CompanyName} help you? `;

export const KeywordsPages = `Mistress Diva, Dominatrix, BDSM, Femdom, professional dominatrix, dungeon, fetish, submission, Mistress sessions, findom, ${LocationCity} dominatrix, latex dominatrix, pegging, roleplay, domination, empowerment, sensuality`;

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 15000;
export const CookiePolicyName = 'CookiePolicy';

// Pages
export const INDEX_PAGE_URL = '/';
export const HOME_PAGE_URL = '/home';
export const ABOUT_ME_PAGE_URL = '/about-me';
export const GALLERY_PAGE_URL = '/gallery';
export const OPPORTUNITIES_PAGE_URL = '/opportunities';
export const SERVICES_PAGE_URL = '/services';
export const REVIEWS_PAGE_URL = '/reviews';
export const CONTACT_PAGE_URL = '/contact-me';
export const LINKS_PAGE_URL = '/links';
export const POLICIES_PAGE_URL = '/user-agreements';
export const ADMIN_PAGE_URL = '/admin';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// URL
export const FULL_BUSINESS_URL = 'https://www.mistress-diva.com';
export const SHORT_BUSINESS_URL = 'mistress-diva.com';
export const DISPLAY_BUSINESS_URL = 'www.mistress-diva.com';

// API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
export const SUBMIT_CONTACT_FORM_API = '/contact/submit-form'; // userId

// Bot Data
export const BotName = 'Jerry';

// Social Media Services
export const FACEBOOK_SERVICE = 'facebook';
export const INSTAGRAM_SERVICE = 'instagram';
export const GOOGLE_SERVICE = 'google';
export const GITHUB_SERVICE = 'github';
export const APPLE_SERVICE = 'apple';
export const X_SERVICE = 'x';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';
export const YOUTUBE_URL = 'https://youtube.com/';
export const TIKTOK_URL = 'https://tiktok.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

export const FACEBOOK_NAME = 'mistress-diva';
export const INSTAGRAM_NAME = 'mistress-diva';
export const LINKEDIN_NAME = 'mistress-diva';

export const FACEBOOK_BUSINESS_URL = `https://www.facebook.com/company/mistress-diva`;
export const INSTAGRAM_BUSINESS_URL = `https://instagram.com/mistress-diva`;
export const LINKEDIN_BUSINESS_URL = `https://www.linkedin.com/mistress-diva`;
export const GITHUB_BUSINESS_URL = `https://www.github.com/mistress-diva`;
export const GOOGLE_BUSINESS_URL = `https://www.google.com/mistress-diva`;
